export default __webpack_public_path__ + "static/media/shieldsweep1.811619ee.png";